import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

type MotionRevealProps = {
  children: React.ReactNode;
  className?: string;
  delayMs?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  distance?: number;
  once?: boolean;
};

export function MotionReveal({
  children,
  className = '',
  delayMs = 0,
  direction = 'up',
  distance = 30,
  once = true,
}: MotionRevealProps) {
  const shouldReduceMotion = useReducedMotion();

  const directionOffset = {
    up: { y: distance },
    down: { y: -distance },
    left: { x: distance },
    right: { x: -distance },
    none: {},
  };

  const initial = { opacity: 0, ...directionOffset[direction] };

  return (
    <motion.div
      className={className}
      initial={shouldReduceMotion ? false : initial}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once, margin: '-50px' }}
      transition={{
        duration: shouldReduceMotion ? 0 : 0.7,
        delay: shouldReduceMotion ? 0 : delayMs / 1000,
        ease: [0.25, 0.4, 0.25, 1],
      }}
    >
      {children}
    </motion.div>
  );
}
